import React, { Component } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from "primereact/button";
import axiosClient from '../constants';
import { Messages } from 'primereact/messages';
import { Link } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import {TermsConditions} from './TermsConditions'
import ReCAPTCHA from "react-google-recaptcha";

export default class Register extends Component {
	constructor(props) {
		super(props);
		this.state = {
            companyName:'',
            yourName:'',
			phone:null,
			userName: '',
			password: '',
			tenantid:'public',
			licenseDialog: false,
			name: '',
			org: '',
			request: '',
			version: { version: null },
			badCreds: false,
			displayConfirmationDialog:false,
			displayTermsDialog:false,
			agreeToTerms:false,
			captchaActive:false,
			site : process.env.REACT_APP_SITE_KEY
		};
	}

	componentDidMount() {
		axiosClient.get("/config/version")
			.then(res => this.setState({ version: res.data }))
			.catch(error => {
				let msg = { severity: 'error', summary: 'Error occurred', detail: "Cannot access the App. Is the App running?" + error };
				this.messages.show(msg);
			});

	}
	 
	register()
	{

		this.setState({displayConfirmationDialog:false})	
			var newUser={
		id:this.state.userName,
		tenantid:this.state.tenantid,
		groupid:'',
		subgroupid:'',
		role:'UTILITY-USER',
		password:this.state.password,
		fname:this.state.yourName,
		phone:this.state.phone,
		lname:'',
		email:this.state.userName,
		usergroup:''
		}
					axiosClient.post(`/generate-registration-link/${this.state.userName}`,newUser)
		.then(res => {
			if (res && res.status === 200) {
				this.messages.show({ severity: 'success', summary: null, detail: 'A verification link was sent to your email address' });
			} else {
				this.messages.show({ severity: 'error', summary: null, detail: `Couldn't send a verification link, check your user id.` });
			}
		}).catch(err => {
			console.error(err);
		});
		
	
}
render() {
		const onChange= (value) =>{
			//console.log("Captcha value:", value);
			this.setState(({
		captchaActive: !this.state.captchaActive
		}));
		
		}

	const checkboxHandler=() => {
			this.setState(prevState => ({
				agreeToTerms: !prevState.agreeToTerms
			  }));
			
	}
		const confirmationDialogFooter =(
            <div>
                <Button icon="pi pi-check" onClick={()=>this.register()} label="Yes" /> 
                <Button icon="pi pi-times" onClick={() => this.setState({displayConfirmationDialog:false})} label="No" className="p-button-secondary" />
            </div>
        );
		const checkUserSession = (e)=>{
			e.preventDefault();
			axiosClient.get(`/check-user-exist/${this.state.userName}`).then(resp =>{
				if(resp.data===true){
					this.register();
				}
				if(resp.data===false){

					axiosClient.get(`/check-user-session/${this.state.userName}`).then(res => {
						if(res.data === true){
							this.setState({displayConfirmationDialog:true})
						}
						else{
							this.register();
						}
					})
				}
			})
			
		}
	
		function handleEnter(event) {
			if (event.keyCode === 13) {
			  const form = event.target.form;
			  const index = Array.prototype.indexOf.call(form, event.target);
			  form.elements[index + 1].focus();
			  event.preventDefault();
			}
		  }

		return <div className="login-body">
			<div className="card login-panel p-fluid">
				<div className="login-panel-content">
					<div className="p-grid">
						<div className="p-col-12" style={{ textAlign: 'left' }}>
							<img src="assets/layout/images/l.png" alt="login" />
						</div>
						<div className="p-col-12" style={{ textAlign: 'left' }}>
							<h2 className="welcome-text">Register</h2>
						</div>
						<form className="p-col-12" onSubmit={checkUserSession} >
                        <div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Company Name</label>
								<div className="login-input">
									<InputText placeholder="Company Name" value={this.state.companyName} onChange={e => this.setState({ companyName: e.target.value })} onKeyDown={handleEnter} required/>
								</div>
							</div>

							<div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Your Name</label>
								<div className="login-input">
									<InputText placeholder="Your Name" value={this.state.yourName} onChange={e => this.setState({ yourName: e.target.value })} onKeyDown={handleEnter} required/>
								</div>
							</div>
							<div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Mobile Number</label>
								<div className="login-input">
									<InputText placeholder="Your Phone Number" value={this.state.phone} onChange={e => this.setState({ phone: e.target.value })} onKeyDown={handleEnter} pattern="[1-9]{1}[0-9]{9}" required/>
								</div>
							</div>
                            <div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Email Address/Username</label>
								<div className="login-input">
									<InputText placeholder="Username" value={this.state.userName} onChange={e => this.setState({ userName: e.target.value })} onKeyDown={handleEnter} required />
								</div>
							</div>
							<div className="p-col-12" style={{ textAlign: 'left' }}>
								<label className="login-label">Password</label>
								<div className="login-input">
									<InputText type="password" placeholder="Password" value={this.state.password} onChange={e => this.setState({ password: e.target.value })} onKeyDown={handleEnter} required/>
								</div>
							</div>
							<Messages ref={(el) => this.messages = el} />
							<ReCAPTCHA
                             sitekey={this.state.site}
                             onChange={onChange}
							  />

							<div>
                 				 <input type="checkbox" id="agree" onChange={checkboxHandler} disabled={!this.state.captchaActive} />
        						  <label htmlFor="agree"> I agree to <button onClick={(e) =>{e.preventDefault(); this.setState({displayTermsDialog:true})}} style={{background:"none",outline:"none",border:"none",color:"white",fontWeight:"bolder",cursor:"pointer"}}>terms and conditions</button></label>
        					</div>
							<div className="p-col-12 p-md-12 button-pane">
								<Button
									disabled={!this.state.agreeToTerms}
									type="submit"
									className="p-button-danger"
									label="Register" 
									// onClick={checkUserSession}
									/>
							</div>
						</form>
					
                            <div className="p-col-12 p-md-12">
							<h3>Already have an account? <Link to="/login" >Login</Link></h3>
							<br />
						</div>

		  							<Dialog header="Confirmation" visible={this.state.displayConfirmationDialog} onHide={() => this.setState({displayConfirmationDialog:false})} style={{ width: '450px' }} modal={true} footer={confirmationDialogFooter}>
						    <div className="confirmation-content" >
                                <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem',color:"black" }} />
                                <span style={{color:"black"}}>The confirmation link has already been sent to your email . Do you want to send again?</span>
                            </div>
                            </Dialog>
                                   
								   <Dialog header="Terms & Conditions" visible={this.state.displayTermsDialog} onHide={() => this.setState({displayTermsDialog:false})} style={{ width: '750px' }}>
								    <TermsConditions></TermsConditions>

								   </Dialog>
					
						<div className="p-col-12 p-md-12">
							<span> Build version: {this.state.version.version}</span>
						</div>
					</div>
				</div>
			</div>
		</div>
	}
}